module.exports = __webpack_public_path__ + "staticcomp/img/cover.594b777.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3/9/cover.jpg
// module id = 8d1n
// module chunks = 39